import { useTheme } from '@material-ui/core';
import * as React from 'react';
import { iconFillColor } from '../../theme';
import { DefaultIconType } from './types';

export const SupportIcon: React.FC<DefaultIconType> = ({
  active = false,
  width = 24,
  height = 24,
}) => {
  const { splitcPalette, palette } = useTheme();
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 23L9 20H4.5C4.1 20 3.75 19.8458 3.45 19.5375C3.15 19.2292 3 18.8833 3 18.5V3.5C3 3.1 3.15 2.75 3.45 2.45C3.75 2.15 4.1 2 4.5 2H19.5C19.8833 2 20.2292 2.15 20.5375 2.45C20.8458 2.75 21 3.1 21 3.5V18.5C21 18.8833 20.8458 19.2292 20.5375 19.5375C20.2292 19.8458 19.8833 20 19.5 20H15L12 23ZM4.5 18.5H9.6L12 20.9L14.4 18.5H19.5V3.5H4.5V18.5Z"
        fill={iconFillColor(palette, splitcPalette, active)}
      />
      <path
        d="M12.6 16.275C12.4167 16.4584 12.1917 16.55 11.925 16.55C11.6583 16.55 11.4333 16.4584 11.25 16.275C11.0667 16.0917 10.975 15.8667 10.975 15.6C10.975 15.3334 11.0667 15.1084 11.25 14.925C11.4333 14.7417 11.6583 14.65 11.925 14.65C12.1917 14.65 12.4167 14.7417 12.6 14.925C12.7833 15.1084 12.875 15.3334 12.875 15.6C12.875 15.8667 12.7833 16.0917 12.6 16.275Z"
        fill={iconFillColor(palette, splitcPalette, active)}
      />
      <path
        d="M12.775 11.5875C12.6083 11.9125 12.525 12.3334 12.525 12.85H11.1C11.1 12.2167 11.1792 11.6917 11.3375 11.275C11.4958 10.8584 11.8833 10.3584 12.5 9.77505C12.9333 9.35838 13.2417 8.99588 13.425 8.68755C13.6083 8.37922 13.7 8.05838 13.7 7.72505C13.7 7.25838 13.5458 6.89172 13.2375 6.62505C12.9292 6.35838 12.5083 6.22505 11.975 6.22505C11.475 6.22505 11.0417 6.34588 10.675 6.58755C10.3083 6.82922 10.0083 7.18338 9.77501 7.65005L8.45001 7.10005C8.73335 6.38338 9.17918 5.82088 9.78751 5.41255C10.3958 5.00422 11.125 4.80005 11.975 4.80005C12.9417 4.80005 13.7083 5.05838 14.275 5.57505C14.8417 6.09172 15.125 6.79172 15.125 7.67505C15.125 8.14172 15.0167 8.58755 14.8 9.01255C14.5833 9.43755 14.2 9.92505 13.65 10.475C13.2333 10.8917 12.9417 11.2625 12.775 11.5875Z"
        fill={iconFillColor(palette, splitcPalette, active)}
      />
    </svg>
  );
};
